// extracted by mini-css-extract-plugin
export default {"root":"Layout_root__GxBbg","wrap":"Layout_wrap__xUh8n","content":"Layout_content__x67QZ"};